import API from '@/shared/plugins/Api/API'

class ConfigurationV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  _appUrl (appName) {
    return `${this.prefix}/application/${encodeURIComponent(appName)}`
  }

  async get (appName) {
    const response = await this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/configuration`
    })
    return response?.configuration ?? response
  }

  async update (appName, configuration) {
    const response = await this.request({
      method: 'put',
      url: `${this._appUrl(appName)}/configuration`,
      data: configuration
    })
    return response?.configuration ?? response
  }
}

export default ConfigurationV3
